<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :module_name="page.name"/>
    <v-row>
      <v-col>
        <base-table ref="base_table" :page="page" @create="create" @edit="edit"/>
      </v-col>
    </v-row>
    <create-translation ref="create_translation" modal_name="create_translation" @refresh="reload"/>
    <edit-translation ref="edit_translation" modal_name="edit_translation" @refresh="reload"/>
  </v-container>
</template>

<script>
import CreateTranslation from "./Create";
import EditTranslation from "./Edit";
import BaseTable from "../../components/commonComponents/BaseTable";
import BaseBreadcrumb from "../../components/commonComponents/BaseBreadcrumb";
export default {
  components: {
    BaseTable,
    BaseBreadcrumb,
    CreateTranslation,
    EditTranslation,
  },
  data() {
    return {
      page: {
        title: this.$store.getters.translate("translations"),
        name: "translations",
        model: "translation",
      },
    };
  },
  methods: {
    create() {
      this.$refs.create_translation.openModal('create_translation');
    },
    edit(item) {
      this.$refs.edit_translation.load(item.id);
    },
    reload() {
      this.$refs.base_table.run();
    },
  },
};
</script>
